import * as React from 'react';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { HeatingType } from '../../store/offer';
import { getOfferType, isUrban } from '../../utils/offer_type';
import * as styles from './index.css';
import { FeatureItem } from './item/index';

export interface IFeaturesCommercialProps {
  offer: IOfferSchema;
}

export class FeaturesCommercial extends React.PureComponent<IFeaturesCommercialProps, {}> {
  public render() {
    const { offer } = this.props;
    const features = getFeaturesByOffer(offer);

    if (features.length === 0) {
      return null;
    }

    return (
      <ul className={styles['container']}>
        {features.map(({ className, name }) => (
          <FeatureItem key={name} name={name} className={className} />
        ))}
      </ul>
    );
  }
}

function getFeaturesByOffer(offer: IOfferSchema) {
  const features = [];
  const offerType = getOfferType(offer);

  if (
    !isUrban(offerType) &&
    (offer.hasHeating ||
      (offer.building && offer.building.heatingType && offer.building.heatingType !== HeatingType.No))
  ) {
    features.push({
      className: 'radiator',
      name: 'Отопление',
    });
  }

  if (offer.passengerLiftsCount && offer.passengerLiftsCount > 0) {
    features.push({
      className: 'lift',
      name: 'Пассажирский лифт',
    });
  }

  if (offer.cargoLiftsCount && offer.cargoLiftsCount > 0) {
    features.push({
      className: 'cargolift',
      name: 'Грузовой лифт',
    });
  }

  if (!offer.passengerLiftsCount && !offer.cargoLiftsCount && offer.hasLift) {
    features.push({
      className: 'lift',
      name: 'Лифт',
    });
  }

  if (offer.loggiasCount && offer.loggiasCount > 0) {
    features.push({
      className: 'big-balcony',
      name: 'Лоджия',
    });
  }

  if (offer.balconiesCount && offer.balconiesCount > 0) {
    features.push({
      className: 'balcony',
      name: 'Балкон',
    });
  }

  if (offer.hasFridge) {
    features.push({
      className: 'fridge',
      name: 'Холодильник',
    });
  }

  if (offer.hasDishwasher) {
    features.push({
      className: 'dishwasher',
      name: 'Посудомоечная машина',
    });
  }

  if (offer.hasWasher) {
    features.push({
      className: 'washing',
      name: 'Стиральная машина',
    });
  }

  if (offer.hasFurniture) {
    features.push({
      className: 'furniture',
      name: 'Мебель в комнатах',
    });
  }

  if (offer.hasKitchenFurniture) {
    features.push({
      className: 'kitchen',
      name: 'Мебель на кухне',
    });
  }

  if (offer.hasConditioner) {
    features.push({
      className: 'cond',
      name: 'Кондиционер',
    });
  }

  if (offer.hasTv) {
    features.push({
      className: 'tv',
      name: 'Телевизор',
    });
  }

  if (offer.hasInternet) {
    features.push({
      className: 'internet',
      name: 'Интернет',
    });
  }

  if (offer.hasPhone) {
    features.push({
      className: 'phone',
      name: 'Телефон',
    });
  }

  if (offer.hasBathtub) {
    features.push({
      className: 'bath',
      name: 'Ванна',
    });
  }

  if (offer.hasShower) {
    features.push({
      className: 'shower',
      name: 'Душевая кабина',
    });
  }

  if (offer.hasBathhouse) {
    features.push({
      className: 'banya',
      name: 'Баня',
    });
  }

  if (offer.hasGarage) {
    features.push({
      className: 'garage',
      name: 'Гараж',
    });
  }

  if (offer.hasPool) {
    features.push({
      className: 'pool',
      name: 'Бассейн',
    });
  }

  if (offer.hasParking || (offer.building && offer.building.parking)) {
    features.push({
      className: 'parking',
      name: 'Паркинг',
    });
  }

  if (offer.building && offer.building.hasGarbageChute) {
    features.push({
      className: 'trash',
      name: 'Мусоропровод',
    });
  }

  if (offer.hasLight) {
    features.push({
      className: 'light',
      name: 'Свет',
    });
  }

  if (offer.hasExtinguishingSystem) {
    features.push({
      className: 'extinguishing_system',
      name: 'Система пожаротушения',
    });
  }

  return features;
}
